/**
 * A utility function to handle promises and catch specific errors.
 * @param promise - The promise to handle.
 * @param errorsToCatch - An array of error classes to catch.
 * @returns A tuple containing either [undefined, result] or [error].
 */
export async function Try<T, E extends new (...args: any[]) => Error>(
  promise: Promise<T>,
  errorsToCatch?: E[] | Record<string, E>
): Promise<[undefined, T] | [InstanceType<E>]> {
  return promise
    .then((result) => {
      return [undefined, result] as [undefined, T];
    })
    .catch((error) => {
      let errorsToCatchArray: E[] = [];

      if (Array.isArray(errorsToCatch)) {
        errorsToCatchArray = errorsToCatch;
      } else if (errorsToCatch) {
        errorsToCatchArray = Object.values(errorsToCatch);
      }

      for (const errorToCatch of errorsToCatchArray) {
        if (error instanceof errorToCatch) {
          return [error as InstanceType<E>];
        }
      }

      if (!errorsToCatch) {
        if (error instanceof Error) {
          return [error as InstanceType<E>];
        }
      }

      throw error;
    });
}

export default Try;
